import React from 'react';
import PropTypes from 'prop-types';

import WidgetErrorMessage from '../../WidgetErrorMessage';
import ThresholdValueDisplay from './ThresholdValueDisplay';

/* eslint-disable complexity */
function isThresholdValid(thresholds) {
    return (
        thresholds &&
        thresholds.length > 0 &&
        thresholds[0].value !== null &&
        thresholds[0].value !== undefined
    );
}
/* eslint-enable complexity */

export default function ThresholdValueDisplayWrapper({
    dashboardLabels,
    numberDecimalFormatter,
    thresholds,
    configuration,
}) {
    if (!isThresholdValid(thresholds)) {
        return (
            <WidgetErrorMessage>
                {dashboardLabels.missingData}
            </WidgetErrorMessage>
        );
    }

    const thresholdValue = numberDecimalFormatter(thresholds[0].value);

    return (
        <ThresholdValueDisplay
            thresholdValue={thresholdValue}
            color={thresholds[0].lineColor}
            suffix={configuration.suffix}
        />
    );
}

ThresholdValueDisplayWrapper.propTypes = {
    configuration: PropTypes.instanceOf(Object),
    dashboardLabels: PropTypes.instanceOf(Object).isRequired,
    numberDecimalFormatter: PropTypes.func.isRequired,
    thresholds: PropTypes.instanceOf(Array).isRequired,
};

ThresholdValueDisplayWrapper.defaultProps = {
    configuration: {},
};
